import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LoadingStatusService } from 'src/app/services/loading-status.service';

@UntilDestroy()
@Component({
  selector: 'app-mat-spinner-overlay',
  templateUrl: './mat-spinner-overlay.component.html',
  styleUrls: ['./mat-spinner-overlay.component.css'],
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
})
export class MatSpinnerOverlayComponent {
  constructor(public lss: LoadingStatusService) { }
}
